<section class="hello-dark" *ngIf="pdv">
    <div *ngIf="showMessageToast" class="supervendedores-new-msg-toast" role="status" aria-live="polite">
        <div class="toast-content">
            <div class="toast-content-text">
                <div class="toast-icon" aria-hidden="true">
                    <img src="assets/img/x-white.svg" alt="Error Supervendedores"/>
                </div>
                <div>
                    <div class="toast-text">Liga de supervendedores</div>
                    <div>{{superventasError}}</div>
                </div>
            </div>

            <button type="button" class="toast-close" (click)="hideNewMessageToast($event)" aria-label="Cerrar">✕</button>
        </div>
    </div>
    <div class="container">
        <div class="row align-items-center">
            <div class="col-12 col-xl">
                <!-- Saludo -->
                <h3>Hola</h3>
                <!-- Nombre de tienda -->
                <h6 *ngIf="pdv && pdv?.info?.tipo_vista !== PDV_MULTIMARCA">
                    {{ pdv.info.name }}
                    <span style="white-space: nowrap;">(id: {{ pdv.info.idpdv }})</span>
                </h6>
            </div>

            <div class="col-12 col-xl-auto">
                <div class="my-2 my-lg-0 menu--tienda">
                    <!-- Ficha del comercial -->
                     <div class="gestor-support">
                        <a href="javascript:void(0)" (click)="openSupportDialog()" class="icons--nav">
                            <img src="./assets/img/phone1.svg" class="img-fluid" width="14">
                            <strong>¿Necesitas ayuda?</strong>
                        </a>
                    </div>

                    <div class="gestor-support gestor-support--no-blink cursor-pointer">
                        <a (click)="goToCommercialPortalUrl()" class="icons--nav">
                            <img src="./assets/img/portal-comercial-icon.png" class="img-fluid" width="14" alt="Ir a la página web del Portal Comercial">
                            <strong>Portal Comercial</strong>
                        </a>
                    </div>

                    <div class="gestor-support gestor-support--no-blink cursor-pointer" *ngIf="pdv.permissions.VISIBLE_SUPERVENDEDORES === 'PERMITIR'">

                        <div class="tooltips">
                            <div (click)="goToSuperventasUrl()">
                                <a href="javascript:void(0)" class="icons--nav superventas-link">
                                    <img src="./assets/img/La_liga_negativo.png"  class="img-fluid" alt="Superventas" style="height:40px">
                                    <span class="dot--error--superventas" *ngIf="showMessageToast"></span>
                                    <span class="spinner" *ngIf="superventasLoading"><img src="./assets/img/spinner-white.svg"></span>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="tooltips" *ngIf="permSv.hasPermFromV2(allPermissions.simyo.permite_vender) || permSv.hasPermFromV2(allPermissions.rep_movil.permite_ventas) || (permSv.hasPermFromV2(allPermissions.orange.permite_ventas_prepago) && permSv.hasPermFromV2(allPermissions.orange.permite_sell_bonos_aditional))">
                        <!-- Link externo -->
                        <a href="javascript:void(0)" (click)="openManualsDialog()" class="icons--nav menu-header">
                            <img src="./assets/img/help-circle1.svg" class="img-fluid icon-nav" width="28">
                        </a>
                        <span class="tooltiptext">Manuales</span>
                    </div>

                    <div class="tooltips" *ngIf="permSv.hasPermFromV2(allPermissions.others.access_clico)">
                        <div (click)="getUrlClico()" [title]="!clicoLoading && clicoError && clicoError !== '' ? clicoError : ''">
                            <a href="javascript:void(0)" class="icons--nav menu-header" *ngIf="!clicoLoading">
                                <img src="./assets/img/school.svg" class="img-fluid icon-nav" width="28">
                            </a>
                            <span class="tooltiptext">Formación Clico</span>
                            <!-- aviso visual de alerta -->
                            <span class="dot--error cursor-pointer" *ngIf="!clicoLoading && clicoError && clicoError !== ''"></span>
                        </div>
                        <a href="javascript:void(0)" class="icons--nav" *ngIf="clicoLoading">
                            <img src="./assets/img/spinner-white.svg" class="img-fluid icon-nav" width="28">
                        </a>
                    </div>

                    <div class="tooltips position-relative" *ngIf="chatIsAvailable">
                        <a href="javascript:void(0)" (click)="openGlobalChat()" class="icons--nav">
                            <img src="./assets/img/chat.svg" class="img-fluid icon-nav icon-chat" width="28">
                            <span class="badge-chat" *ngIf="unreadChatCount > 0 && (!chatIsOpen || chatIsMinimized)">{{ unreadChatCount }}</span>
                        </a>
                        <span class="tooltiptext">Chat</span>
                    </div>

                    <div class="tooltips position-relative" *ngIf="chatSoporteIsAvailable">
                        <a href="javascript:void(0)" (click)="openSupportChat()" class="icons--nav">
                            <img src="./assets/img/chat-soporte.svg" class="img-fluid icon-nav icon-chat" width="28" alt="Chat soporte simyo">
                            <span class="badge-chat" *ngIf="unreadChatSoporteCount > 0 && (!chatSoporteIsOpen || chatSoporteIsMinimized)">{{ unreadChatSoporteCount }}</span>
                        </a>
                        <span class="tooltiptext">Soporte simyo</span>
                    </div>
                </div>
            </div>

          <!--   <div class="mb-4">
                <div class="gestor-support">
                    <a href="/test-component" class="icons--nav">
                        <strong>Probar componentes NUEVOS</strong>
                    </a>
                </div>
            </div> -->
        </div>
    </div>
</section>

<div class="container" *ngIf="pdv && !showRedeemPoints">
    <mat-tab-group #tabGroup dynamicHeight disableRipple class="md-no-animation" [selectedIndex]="currentSelectedIndex" (selectedTabChange)="tabChanged($event)">
        <mat-tab [label]="tabHome.CONTRATACIONES">
            <ng-template mat-tab-label>
                <i-feather name="grid" class="icon--fe"></i-feather>
                <span class="ls-tab">Contrataciones</span>
            </ng-template>
            <app-hm-hiring [tabGroup]="tabGroup" [pdv]="pdv" [dataPoints]="dataPoints" [resumeData]="resumeData"></app-hm-hiring>
        </mat-tab>

        <mat-tab [label]="tabHome.COBERTURA" *ngIf="permSv.hasPermFromV2(allPermissions.rep_movil.permite_ventas) || permSv.hasPermFromV2(allPermissions.simyo.permite_vender_broadband)">
            <ng-template mat-tab-label>
                <i-feather name="map-pin" class="icon--fe"></i-feather>
                <span class="ls-tab">Cobertura</span>
            </ng-template>
            <app-hm-coverage [initCoverage]="changeTab.asObservable()" [pdv]="pdv"></app-hm-coverage>
        </mat-tab>

        <mat-tab [label]="tabHome.OPERACIONES" *ngIf="permSv.hasPermFromV2(allPermissions.others.access_night)">
            <ng-template mat-tab-label>
                <i-feather name="users" class="icon--fe"></i-feather>
                <span class="ls-tab">Operaciones</span>
            </ng-template>
            <app-hm-operations [initOperation]="changeTab.asObservable()"></app-hm-operations>
        </mat-tab>

        <mat-tab [label]="tabHome.OPERACIONES_POSVENTA" *ngIf="permSv.hasPermFromV2(allPermissions.orange.permite_sell_bonos_aditional) && permSv.hasPermFromV2(allPermissions.orange.permite_ventas_prepago)"> <!-- || permSv.hasPermFromV2(allPermissions.jazztel.permite_ventas) -->
            <ng-template mat-tab-label>
                <i-feather name="user-check" class="icon--fe"></i-feather>
                <span class="ls-tab">Operaciones posventa</span>
            </ng-template>
            <app-hm-operations-posventa [initOperationPostpago]="changeTab.asObservable()"></app-hm-operations-posventa>
        </mat-tab>

        <mat-tab [label]="tabHome.VENTAS">
            <ng-template mat-tab-label>
                <i-feather name="pie-chart" class="icon--fe"></i-feather>
                <span class="ls-tab">Mis ventas</span>
            </ng-template>
            <app-hm-sales [tabGroup]="tabGroup" [initSales]="changeTab.asObservable()"></app-hm-sales>
        </mat-tab>

        <mat-tab [label]="tabHome.COMISIONES" *ngIf="permSv.hasPermFromV2(allPermissions.others.comissions_permitir) && pdv?.info?.tipo_vista !== PDV_MULTIMARCA && this.permSv.hasPermFromV2(allPermissions.others.access_night)">
            <ng-template mat-tab-label>
                <i-feather name="plus-circle" class="icon--fe"></i-feather>
                <span class="ls-tab">Mis comisiones</span>
            </ng-template>
            <app-hm-commissions [pdv]="pdv"></app-hm-commissions>
        </mat-tab>

        <mat-tab [label]="tabHome.TARIFAS">
            <ng-template mat-tab-label>
                <i-feather name="list" class="icon--fe"></i-feather>
                <span class="ls-tab">Tarifas</span>
            </ng-template>
            <app-hm-rates [initRates]="changeTab.asObservable()"></app-hm-rates>
        </mat-tab>

        <mat-tab [label]="tabHome.PUNTOS" *ngIf="permSv.hasPermFromV2(allPermissions.others.access_points) && this.permSv.hasPermFromV2(allPermissions.others.access_night)">
            <ng-template mat-tab-label>
                <i-feather name="gift" class="icon--fe"></i-feather>
                <span class="ls-tab">¡Atrévete!</span>
            </ng-template>
            <app-home-points #tabPoints [content]="showContentPoints" [pdv]="pdv" (onGoToRedeemPoints)="goToRedeemPoints($event)" (onUpdatePoints)="updatePoints($event)" (onUpdateResume)="updateResume($event)"></app-home-points>
        </mat-tab>

    </mat-tab-group>

    <div class="row">
        <div class="col-xl-12">
            <hr class="mt-5">

            <div class="footer--hr">
                <p>
                    <span class="me-3">Usuario: {{ pdv.info.username }}</span>
                    <span class="me-3" *ngIf="lastAccess">Última conexión: {{ lastAccess }}</span>
                    <span class="me-3">Versión Digo: {{ version }}</span>
                    <a *ngIf="tracerService.isActive"
                        (click)="tracerService.copiarLogAlPortapapeles()"
                        class="enlace-tracer">
                        📋 Copiar Historial de Pasos (Bug)
                    </a>
                </p>
            </div>
        </div>
    </div>
</div>

<app-point-order *ngIf="showRedeemPoints" [reward]="rewardSelected" [amountSelected]="amountSelected" [availablePoints]="availablePoints" [pdv]="pdv" (onGoBack)="goBackHomePoints($event)"></app-point-order>
<br><br><br>
